/* eslint-disable */
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { getAccessToken, getRefreshToken, setAccessToken, setRefreshToken } from "../../helpers/cookies";
import { AuthApi, GrantType, OauthTokenResponse, RefreshTokenRequest } from "../users/AuthApi";
import { HttpStatusCode } from "../HttpStatusCodes";

interface Subscribers {
	resolve: (r: AxiosRequestConfig) => void;
	reject: (e: any) => void;
}

let subscribers: Subscribers[] = [];
let isRefreshing = false;
const retries = 1;

export const onFulfilled = <T>(response: AxiosResponse<T>): T => {
	if (response.config.url?.includes("export")) return response as any;
	return response.data;
};

export const onRejected = async (error: any) => {
	const request = error.config;

	if (request.url.includes("auth")) {
		return Promise.reject();
	}

	if (error.status === HttpStatusCode.UNAUTHORIZED || error.status === HttpStatusCode.FORBIDDEN) {
		// eslint-disable-next-line no-plusplus
		request.retry = typeof request.retry === "undefined" ? 0 : ++request.retry;

		if (request.retry === retries) {
			return Promise.reject();
		}

		if (!isRefreshing) {
			isRefreshing = true;

			const data: RefreshTokenRequest = {
				client_id: process.env.REACT_APP_CLIENT_ID!,
				client_secret: process.env.REACT_APP_CLIENT_SECRET!,
				refresh_token: getRefreshToken(),
				grant_type: GrantType.token,
			};

			AuthApi.token(data)
				.then((response) => {
					const { access_token, expires_in, refresh_token } = response as OauthTokenResponse;
					setRefreshToken(refresh_token, { path: "/" });
					setAccessToken(access_token, {
						expires_in,
					});
					request.headers.Authorization = `Bearer ${getAccessToken()}`;

					Promise.all(subscribers.map((s) => s.resolve(request)));
					subscribers = [];
				})
				.catch(() => {
					Promise.all(subscribers.map((s) => s.reject(request)));
					subscribers = [];
				})
				.finally(() => {
					isRefreshing = false;
				});
		}

		return new Promise((res, rej) => {
			subscribers.push({
				resolve: (request: AxiosRequestConfig) => res(axios(request).then((r) => r.data)),
				reject: (err: any) => rej(err),
			});
		});
	}

	if (error.status === HttpStatusCode.UNPROCESSABLE_ENTITY) {
		return Promise.reject(error);
	}

	if (error.status === HttpStatusCode.INTERNAL_SERVER_ERROR) {
		// const redirectUrl = window.location.pathname.includes("error") ? "/" : window.location.pathname;
		// window.location.href = `/${Routes.error500}?from=${redirectUrl}`;
		return Promise.reject();
	}

	return Promise.reject();
};

export const getRequestConfig = (config: AxiosRequestConfig): AxiosRequestConfig => {
	const headers: AxiosRequestConfig["headers"] = {
		"Content-type": "application/vnd.api+json",
	};

	if (!config.url?.includes("oauth")) {
		headers.Accept = "application/vnd.api+json";
	}

	if (config.url?.includes("export")) {
		headers.Accept = "application/zip";
	}

	// if (!config.url?.includes("questions/import")) {
	//   headers.Accept = "application/json";
	// }

	const accessToken = getAccessToken();
	if (accessToken) {
		headers.Authorization = `Bearer ${accessToken}`;
	}

	return {
		...config,
		headers: { ...headers, ...config.headers },
	};
};
